import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          VRLMS - Virtual Reality LMS
        </p>
        <a
          className="App-link"
          href="https://vimeo.com/358547629"
          target="_blank"
          rel="noopener noreferrer"
        >
          Demo
        </a>
      </header>
    </div>
  );
}

export default App;
